import {
  GlobalStylesDefault,
  GlobalStylesEnvironmental,
  GlobalStylesMinimal,
  GlobalStylesTerminal,
  GlobalStylesTube,
} from './sets/index';

export const LOCAL_STORAGE_THEME = 'theme';

// eslint-disable-next-line no-shadow
export enum THEME_OPTIONS {
  DEFAULT = 'default',
  ENVIRONMENTAL = 'environmental',
  MINIMAL = 'minimal',
  TERMINAL = 'terminal',
  TUBE = 'tube',
}

export const THEMES = [
  THEME_OPTIONS.DEFAULT,
  THEME_OPTIONS.TERMINAL,
  THEME_OPTIONS.MINIMAL,
  THEME_OPTIONS.ENVIRONMENTAL,
  THEME_OPTIONS.TUBE,
];

export const THEMES_GLOBAL_STYLES = {
  [THEME_OPTIONS.DEFAULT]: <GlobalStylesDefault />,
  [THEME_OPTIONS.TERMINAL]: <GlobalStylesTerminal />,
  [THEME_OPTIONS.MINIMAL]: <GlobalStylesMinimal />,
  [THEME_OPTIONS.ENVIRONMENTAL]: <GlobalStylesTube />,
  [THEME_OPTIONS.TUBE]: <GlobalStylesEnvironmental />,
};
